import { render, staticRenderFns } from "./RestoreFolderDialog.vue?vue&type=template&id=0a484a3c&scoped=true"
import script from "./RestoreFolderDialog.vue?vue&type=script&lang=js"
export * from "./RestoreFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a484a3c",
  null
  
)

export default component.exports